import { DOCUMENT, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { UtilsService } from 'src/services/utils/utils.service';
import { getCookieDomain } from 'src/shared/helpers/get-cookie-domain/get-cookie-domain';

@Injectable({
    providedIn: 'root',
})
export class TypeformQuizCookieService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly document = inject(DOCUMENT);
    private readonly cookieService = inject(CookieService);
    private readonly utilsService = inject(UtilsService);

    private readonly daysQueryParamName = 'days';
    private readonly daysCookieName = 'quiz_days';
    private readonly cookieLifetimeDays = 30;

    public saveDaysFromQuery(): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }

        const days = new URLSearchParams(this.document.location?.search || '').get(this.daysQueryParamName);

        if (!days || !/^\d+(\.\d+)?$/.test(days)) {
            return;
        }

        const roundedDays = Math.ceil(Number(days));

        if (!Number.isSafeInteger(roundedDays)) {
            return;
        }

        this.cookieService.set(this.daysCookieName, String(roundedDays), {
            path: '/',
            domain: getCookieDomain(),
            expires: this.utilsService.getDatePlusDays(this.cookieLifetimeDays),
        });
    }
}
